import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    addParticipant,
    addPresentation,
    addSoloParticipant,
    cancelEdit,
    clearErrors,
    deletePresentation,
    editPresentation,
    editSoloCategory,
    getApplication,
    removeParticipant,
    removeSoloParticipant,
    revertApplication,
    savePresentation,
    saveSoloCategory,
    sendApplication,
    updateParticipantSearchText,
    updatePresentationName
} from "../../actions/application";
import {Button, Grid, Header, Icon, Label, Loader, Message, Popup, Segment, Table} from "semantic-ui-react";
import ParticipantList from "../application/ParticipantList";
import TextField from "../common/TextField";
import ErrorModal from "../common/ErrorModal";

class Application extends Component {

    componentDidMount() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        } else {
            this.props.dispatch(getApplication(this.props.match.params.applicationId));
        }
    }

    componentDidUpdate() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        }
    }

    onClickEditSoloCategory(e, category) {
        this.props.dispatch(editSoloCategory(category));
    }

    onClickAddPresentation(e, category) {
        this.props.dispatch(addPresentation(category));
    }

    onClickEditPresentation(e, category, presentation) {
        this.props.dispatch(editPresentation(category, presentation));
    }

    onClickDeletePresentation(e, category, presentation) {
        this.props.dispatch(deletePresentation(category, presentation));
    }

    onClickSavePresentation(e) {
        if (this.props.presentationNameErrors.length === 0
            || this.props.presentationParticipantsErrors.length === 0) {
            this.props.dispatch(savePresentation(
                this.props.application,
                this.props.category,
                this.props.presentation
            ));
        }
    }

    onClickCancelEdit(e) {
        this.props.dispatch(cancelEdit());
    }

    onChangePresentationName(e) {
        this.props.dispatch(updatePresentationName(e.target.value));
    }

    onRemoveParticipant(e, participant) {
        this.props.dispatch(removeParticipant(participant))
    }

    onAddParticipant(e, participant) {
        this.props.dispatch(addParticipant(participant))
    }

    onRemoveSoloParticipant(e, participant) {
        this.props.dispatch(removeSoloParticipant(participant))
    }

    onAddSoloParticipant(e, participant) {
        this.props.dispatch(addSoloParticipant(participant))
    }

    onClickSaveSoloCategory(e) {
        this.props.dispatch(saveSoloCategory(
            this.props.application,
            this.props.category,
            this.props.soloParticipants
        ));
    }

    onChangeParticipantSearchText(e) {
        this.props.dispatch(updateParticipantSearchText(e.target.value))
    }

    onClickRefreshApplication(e) {
        this.props.dispatch(getApplication(this.props.application.id));
    }

    onClickSendApplication(e) {
        this.props.dispatch(sendApplication(this.props.application));
    }

    onClickRevertApplication(e) {
        this.props.dispatch(revertApplication(this.props.application));
    }

    onCloseErrorModal(e) {
        this.props.dispatch(clearErrors());
    }

    onClickPayments(e) {
        this.props.history.push("/zgloszenia/" + this.props.match.params.applicationId + "/oplaty");
    }

    onClickBack(e) {
        this.props.history.push("/zgloszenia");
    }

    render() {
        return (
            <div style={{margin: "1rem 0"}}>
                {this.renderLoader()}
                {this.renderLoadingError()}
                {this.renderErrorModals()}
                {this.renderApplication()}
            </div>
        );
    }

    renderErrorModals() {
        return <div>
            <ErrorModal open={this.props.savingPresentationFailed}
                        onClose={(e) => {
                            this.onCloseErrorModal(e)
                        }}
                        header="Zapisywanie prezentacji nie powiodło się"
                        error={this.props.savingPresentationError}/>
            <ErrorModal open={this.props.deletingPresentationFailed}
                        onClose={(e) => {
                            this.onCloseErrorModal(e)
                        }}
                        header="Usuwanie prezentacji nie powiodło się"
                        error={this.props.deletingPresentationError}/>
            <ErrorModal open={this.props.sendingApplicationFailed}
                        onClose={(e) => {
                            this.onCloseErrorModal(e)
                        }}
                        header="Wysyłanie zgłoszenia nie powiodło się"
                        error={this.props.sendingApplicationError}/>
            <ErrorModal open={this.props.revertingApplicationFailed}
                        onClose={(e) => {
                            this.onCloseErrorModal(e)
                        }}
                        header="Wycofywanie zgłoszenia nie powiodło się"
                        error={this.props.revertingApplicationError}/>
        </div>
    }

    renderLoader() {
        return this.props.loadingApplication &&
            <Segment textAlign='center' padded='very'><Loader inline active content='Wczytywanie zgłoszenia'/></Segment>
    }

    renderLoadingError() {
        return !this.props.loadingApplication && this.props.loadingApplicationFailed
            && <Message negative
                        icon='exclamation triangle'
                        header='Nie udało sie pobrać zgłoszenia'
                        content={this.props.loadingApplicationError}/>
    }

    renderApplication() {
        return !this.props.loadingApplication && !this.props.loadingApplicationFailed
            && [this.renderHeader(), this.renderCategories()]
    }

    renderHeader() {
        return <Table key={-1} attached="top" className="application-header">
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan={2}>
                        <Header>
                            <Icon name="trophy"/>
                            <Header.Content>{this.props.contest.name}
                                <Header.Subheader>
                                    {this.props.application.status === 'DRAFT' && 'Zgłoszenie w przygotowaniu'}
                                    {this.props.application.status === 'SENT' && 'Zgłoszenie wysłane'}
                                    {this.props.application.status === 'REJECTED' && 'Zgłoszenie odrzucone'}
                                    {this.props.application.status === 'APPROVED' && 'Zgłoszenie zaakceptowane'}
                                </Header.Subheader>
                            </Header.Content>
                        </Header>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <Table.Row>
                    <Table.Cell>
                        <Popup trigger={<Label size='large'><Icon
                            name='folder open outline'/> {this.props.application.categoryCount}
                        </Label>}
                               content="Ilość kategorii z przynajmniej jedną prezentacją"
                               position="bottom left"
                               inverted/>
                        <Popup
                            trigger={<Label size='large'><Icon name='image'/> {this.props.application.presentationCount}
                            </Label>}
                            content="Ilość prezentacji"
                            position="bottom left"
                            inverted/>
                        <Popup
                            trigger={<Label size='large'><Icon name='users'/> {this.props.application.participantCount}
                            </Label>}
                            content="Ilość zgłoszonych zawodników"
                            position="bottom left"
                            inverted/>
                        <Popup trigger={<Label size='large'><Icon
                            name='money bill alternate outline'/> {this.props.application.totalCost}
                        </Label>}
                               content="Całkowity koszt zgłoszenia"
                               position="bottom left"
                               inverted/>
                    </Table.Cell>
                    <Table.Cell collapsing textAlign="right">
                        <Popup trigger={<Button icon="arrow left"
                                                disabled={typeof this.props.category.id !== 'undefined'
                                                || typeof this.props.presentation.id !== 'undefined'
                                                || this.props.savingPresentation
                                                || this.props.deletingPresentation
                                                || this.props.sendingApplication
                                                || this.props.revertingApplication}
                                                onClick={(e) => this.onClickBack(e)}/>}
                               content="Wróć do listy zgłoszenia"
                               position="bottom left"
                               inverted/>
                        <Popup trigger={<Button color="yellow"
                                                icon="money bill alternate outline"
                                                disabled={typeof this.props.category.id !== 'undefined'
                                                || typeof this.props.presentation.id !== 'undefined'
                                                || this.props.savingPresentation
                                                || this.props.deletingPresentation
                                                || this.props.sendingApplication
                                                || this.props.revertingApplication}
                                                onClick={(e) => this.onClickPayments(e)}/>}
                               content="Przejdź do listy opłat"
                               position="bottom right"
                               inverted/>
                        <Popup trigger={<Button secondary
                                                icon="refresh"
                                                disabled={typeof this.props.category.id !== 'undefined'
                                                || typeof this.props.presentation.id !== 'undefined'
                                                || this.props.savingPresentation
                                                || this.props.deletingPresentation
                                                || this.props.sendingApplication
                                                || this.props.revertingApplication}
                                                onClick={(e) => this.onClickRefreshApplication(e)}/>}
                               content="Odśwież"
                               position="bottom right"
                               inverted/>
                        {(this.props.application.status === "SENT" || this.props.application.status === "APPROVED")
                        && <Popup trigger={<Button color="pink"
                                                   as="a"
                                                   href={"/zgloszenie/pdf/" + this.props.application.uuid}
                                                   download
                                                   icon="download"
                                                   disabled={typeof this.props.category.id !== 'undefined'
                                                   || typeof this.props.presentation.id !== 'undefined'
                                                   || this.props.savingPresentation
                                                   || this.props.deletingPresentation
                                                   || this.props.sendingApplication
                                                   || this.props.revertingApplication}/>}
                                  content={"Pobierz zgłoszenie"}
                                  position="bottom right"
                                  inverted/>}
                        {this.props.application.status === 'DRAFT'
                        && this.props.contest.registrationOpen
                        && <Popup trigger={<Button positive
                                                   icon="send"
                                                   loading={this.props.sendingApplication}
                                                   disabled={typeof this.props.category.id !== 'undefined'
                                                   || typeof this.props.presentation.id !== 'undefined'
                                                   || this.props.savingPresentation
                                                   || this.props.deletingPresentation
                                                   || this.props.sendingApplication
                                                   || this.props.revertingApplication}
                                                   onClick={(e) => this.onClickSendApplication(e)}/>}
                                  content="Wyślij zgłoszenie"
                                  position="bottom right"
                                  inverted/>}
                        {this.props.application.status === 'SENT'
                        && this.props.contest.registrationOpen
                        && <Popup trigger={<Button color='orange'
                                                   icon="undo"
                                                   loading={this.props.revertingApplication}
                                                   disabled={typeof this.props.category.id !== 'undefined'
                                                   || typeof this.props.presentation.id !== 'undefined'
                                                   || this.props.savingPresentation
                                                   || this.props.deletingPresentation
                                                   || this.props.sendingApplication
                                                   || this.props.revertingApplication}
                                                   onClick={(e) => this.onClickRevertApplication(e)}/>}
                                  content="Wycofaj zgłoszenie"
                                  position="bottom right"
                                  inverted/>}
                    </Table.Cell>
                </Table.Row>
            </Table.Body>
        </Table>
    }

    renderCategories() {
        return this.props.categories.map((category, index) => {
            if (this.props.application.status === 'DRAFT' || category.presentations.length > 0) {
                return this.renderCategory(this.props.category.id === category.id ? this.props.category : category, index)
            }
            return false;
        })
    }

    renderCategory(category, index) {
        const last = this.props.categories.length === index + 1;
        const solo = category.minPresentationSize === 1 && category.maxPresentationSize === 1;
        return <Table key={index} attached={last ? "bottom" : true}>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>{category.name}</Table.HeaderCell>
                    <Table.HeaderCell collapsing textAlign="right">
                        {this.props.application.status === 'DRAFT'
                        && this.props.contest.registrationOpen
                        && solo && <Popup trigger={<Button primary
                                                           icon='edit'
                                                           disabled={typeof this.props.category.id !== 'undefined'
                                                           || typeof this.props.presentation.id !== 'undefined'
                                                           || this.props.savingPresentation
                                                           || this.props.deletingPresentation
                                                           || this.props.sendingApplication
                                                           || this.props.revertingApplication}
                                                           onClick={(e) => this.onClickEditSoloCategory(e, category)}/>}
                                          content="Edytuj listę prezentacji"
                                          position="bottom right"
                                          inverted/>}
                        {this.props.application.status === 'DRAFT'
                        && this.props.contest.registrationOpen
                        && !solo && <Popup trigger={<Button positive
                                                            icon="add"
                                                            disabled={typeof this.props.category.id !== 'undefined'
                                                            || typeof this.props.presentation.id !== 'undefined'
                                                            || this.props.savingPresentation
                                                            || this.props.deletingPresentation
                                                            || this.props.sendingApplication
                                                            || this.props.revertingApplication}
                                                            onClick={(e) => this.onClickAddPresentation(e, category)}/>}
                                           content="Dodaj prezentację"
                                           position="bottom right"
                                           inverted/>}
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {solo && this.props.category.id === category.id
                    ? this.renderEditSoloCategory()
                    : this.renderPresentations(category)}
            </Table.Body>
        </Table>
    }

    renderEditSoloCategory() {
        return <Table.Row>
            <Table.Cell>
                <Grid columns="equal">
                    <Grid.Row>
                        <Grid.Column>
                            <ParticipantList participants={this.props.soloParticipants}
                                             emptyMessage="Brak przypisanych zawodników"
                                             onClickParticipant={(e, participant) => this.onRemoveSoloParticipant(e, participant)}/>
                        </Grid.Column>
                        <Grid.Column>
                            <TextField placeholder="Wyszukiwanie"
                                       disabled={this.props.savingPresentation}
                                       value={this.props.participantSearchText}
                                       onChange={(e) => this.onChangeParticipantSearchText(e)}/>
                            <ParticipantList participants={this.props.availableParticipants}
                                             emptyMessage="Brak dostępnych zawodników"
                                             onClickParticipant={(e, participant) => this.onAddSoloParticipant(e, participant)}/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Table.Cell>
            <Table.Cell collapsing textAlign="right" verticalAlign="top">
                <Popup trigger={<Button positive
                                        icon='save outline'
                                        loading={this.props.savingPresentation}
                                        disabled={this.props.savingPresentation
                                        || this.props.deletingPresentation}
                                        onClick={(e) => this.onClickSaveSoloCategory(e)}/>}
                       content="Zapisz"
                       position="bottom right"
                       inverted/>
                <Popup trigger={<Button icon="cancel"
                                        disabled={this.props.savingPresentation}
                                        onClick={(e) => this.onClickCancelEdit(e)}/>}
                       content="Anuluj"
                       position="bottom right"
                       inverted/>
            </Table.Cell>
        </Table.Row>
    }

    renderPresentations(category) {
        return category.presentations.map((presentation, index) =>
            this.props.presentation.id === presentation.id
                ? this.renderEditPresentation(index)
                : this.renderPresentation(category, presentation, index))
    }

    renderPresentation(category, presentation, index) {
        const solo = category.minPresentationSize === 1 && category.maxPresentationSize === 1;
        const duet = category.minPresentationSize === 2 && category.maxPresentationSize === 2;
        return <Table.Row key={index}>
            <Table.Cell colSpan={solo ? 2 : 1}>
                {(solo || duet) && presentation.name}
                {!solo && !duet && <strong>{presentation.name}</strong>}
                {!solo && !duet && <p style={{fontStyle: 'italic', color: 'grey'}}>
                    {presentation.participants.map((participant, i) => [
                        i > 0 ? ', ' : '', participant.firstName, ' ', participant.lastName
                    ])}
                </p>}
            </Table.Cell>
            {!solo && <Table.Cell collapsing textAlign="right">
                {this.props.application.status === 'DRAFT'
                && this.props.contest.registrationOpen
                && <Popup trigger={<Button primary
                                           icon='edit'
                                           disabled={typeof this.props.category.id !== 'undefined'
                                           || typeof this.props.presentation.id !== 'undefined'
                                           || this.props.savingPresentation
                                           || this.props.deletingPresentation
                                           || this.props.sendingApplication
                                           || this.props.revertingApplication}
                                           onClick={(e) => this.onClickEditPresentation(e, category, presentation)}/>}
                          content="Edytuj prezentację"
                          position="bottom right"
                          inverted/>}
                {this.props.application.status === 'DRAFT'
                && this.props.contest.registrationOpen
                && <Popup trigger={<Button negative
                                           icon="trash"
                                           loading={this.props.deletingPresentation
                                           && this.props.deletingPresentationId === presentation.id}
                                           disabled={typeof this.props.category.id !== 'undefined'
                                           || typeof this.props.presentation.id !== 'undefined'
                                           || this.props.savingPresentation
                                           || this.props.deletingPresentation
                                           || this.props.sendingApplication
                                           || this.props.revertingApplication}
                                           onClick={(e) => this.onClickDeletePresentation(e, category, presentation)}/>}
                          content="Usuń prezentację"
                          position="bottom right"
                          inverted/>}
            </Table.Cell>}
        </Table.Row>
    }

    renderEditPresentation(index) {
        const duet = this.props.category.minPresentationSize === 2 && this.props.category.maxPresentationSize === 2;
        return <Table.Row key={index}>
            <Table.Cell>
                <Grid columns="equal">
                    <Grid.Row>
                        <Grid.Column>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={14}>
                                        <TextField placeholder="Nazwa zespołu"
                                                disabled={duet || this.props.savingPresentation}
                                                value={this.props.presentation.name}
                                                errors={this.props.presentationNameErrors}
                                                onChange={(e) => this.onChangePresentationName(e)}/>
                                    </Grid.Column>
                                    <Grid.Column width={2}>
                                        <Popup  content="Nazwa, która będzie widoczna na listach startowych i będzie nadrukowana na dyplomach" 
                                                trigger={<Button icon color='blue'><Icon name='info' /></Button>}
                                                position="top left"/>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <ParticipantList participants={this.props.presentation.participants}
                                             errors={this.props.presentationParticipantsErrors}
                                             emptyMessage="Brak przypisanych zawodników"
                                             onClickParticipant={(e, participant) => this.onRemoveParticipant(e, participant)}/>
                        </Grid.Column>
                        <Grid.Column>
                            <TextField placeholder="Wyszukiwanie"
                                       disabled={this.props.savingPresentation}
                                       value={this.props.participantSearchText}
                                       onChange={(e) => this.onChangeParticipantSearchText(e)}/>
                            <ParticipantList participants={this.props.availableParticipants}
                                             emptyMessage="Brak dostępnych zawodników"
                                             onClickParticipant={(e, participant) => this.onAddParticipant(e, participant)}/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Table.Cell>
            <Table.Cell collapsing textAlign="right" verticalAlign="top">
                <Popup trigger={<Button positive
                                        icon='save outline'
                                        loading={this.props.savingPresentation}
                                        disabled={this.props.savingPresentation
                                        || this.props.deletingPresentation}
                                        onClick={(e) => this.onClickSavePresentation(e)}/>}
                       content="Zapisz"
                       position="bottom right"
                       inverted/>
                <Popup trigger={<Button icon="cancel"
                                        disabled={this.props.savingPresentation}
                                        onClick={(e) => this.onClickCancelEdit(e)}/>}
                       content="Anuluj"
                       position="bottom right"
                       inverted/>
            </Table.Cell>
        </Table.Row>
    }

}

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated,

        loadingApplication: state.application.loadingApplication,
        loadingApplicationFailed: state.application.loadingApplicationFailed,
        loadingApplicationError: state.application.loadingApplicationError,
        savingPresentation: state.application.savingPresentation,
        savingPresentationFailed: state.application.savingPresentationFailed,
        savingPresentationError: state.application.savingPresentationError,
        deletingPresentation: state.application.deletingPresentation,
        deletingPresentationId: state.application.deletingPresentationId,
        deletingPresentationFailed: state.application.deletingPresentationFailed,
        deletingPresentationError: state.application.deletingPresentationError,

        application: state.application.application,
        contest: state.application.contest,
        categories: state.application.categories,
        participants: state.application.participants,

        category: state.application.category,
        presentation: state.application.presentation,

        presentationNameErrors: state.application.presentationNameErrors,
        presentationParticipantsErrors: state.application.presentationParticipantsErrors,

        participantSearchText: state.application.participantSearchText,
        availableParticipants: state.application.availableParticipants,

        soloParticipants: state.application.soloParticipants,

        sendingApplication: state.application.sendingApplication,
        sendingApplicationFailed: state.application.sendingApplicationFailed,
        sendingApplicationError: state.application.sendingApplicationError,
        revertingApplication: state.application.revertingApplication,
        revertingApplicationFailed: state.application.revertingApplicationFailed,
        revertingApplicationError: state.application.revertingApplicationError
    }
}

export default connect(mapStateToProps)(Application)


// WEBPACK FOOTER //
// ./src/components/routes/Application.js